const states1 = [
    "Andaman and Nicobar Islands (UT)", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar",
    "Chandigarh (UT)", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu (UT)", "Delhi (NCT)",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir (UT)", "Jharkhand",
    "Karnataka", "Kerala", "Ladakh (UT)", "Lakshadweep (UT)", "Madhya Pradesh", "Maharashtra",
    "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry (UT)", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttarakhand", "Uttar Pradesh",
    "West Bengal"
];

const states2 = [
    "Andaman and Nicobar", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar",
    "Chandigarh", "Chhattisgarh", "Dadara and Nagar Havelli", "NCT of Delhi",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu & Kashmir", "Jharkhand",
    "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra",
    "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttarakhand", "Uttar Pradesh",
    "West Bengal"
];


export const CorrectState = (value, state1 = states1, state2 = states2) => {
    if (!value) return '';

    // Ensure proper spacing after comma, if not already
    const normalized = value.replace(/,\s*/g, ', ');

    // Split by ', ' to form an array of state strings
    const parsedValues = normalized.split(', ');

    // Map each parsed value to its corresponding state2 equivalent
    const correctedValues = parsedValues.map(val => {
        const IndexValue = state1.findIndex(state => state === val.trim());
        return IndexValue !== -1 ? state2[IndexValue] : val;
    });

    // Join corrected values with ', ' and return
    return correctedValues.join(', ');
};
